import HiddenField from "@/components/Spellify/HiddenField/HiddenField"
import { ScryfallCard } from "@scryfall/api-types"

import styles from './CardFields.module.scss'
import classNames from "classnames";

type Props = {
  card: ScryfallCard.Normal,
  typeParts: string[],
  oracleTextParts: string[],
  correctGuesses: string[],
  isHardMode?: boolean,
}

const CardFields = ({
    card,
    oracleTextParts,
    correctGuesses,
    typeParts,
    isHardMode=false,
  }: Props) => {

  const artCropStyles = {
    backgroundImage: `url(${card.image_uris ? card.image_uris.art_crop : ''})`,
    backgroundSize: "100%",
  }

  const nameLengthIndex = Math.floor((card.mana_cost || []).length/2 + card.name.length/17)
  const typeLengthIndex = Math.floor((card.type_line.length / 2 + typeParts.length)/2.88)
  const lengthIndex = Math.floor(oracleTextParts.length + card.oracle_text.length/70)

  return (
      <div className={styles.cardfields}>
        {/*<ImageBlur/>*/}
        <div className={styles.nameandmv}>
          <HiddenField 
            className={classNames(styles.cardname, styles[`textSize${Math.min(5, nameLengthIndex)}`])}
            word={card.name}
            correctGuesses={correctGuesses}
          />
          <HiddenField
            className={styles.cardcost!}
            cardfield={"cardcost"}
            word={card.mana_cost || ''}
            correctGuesses={correctGuesses}
          />
        </div>
        <div className={styles.artcrop}>
          <div className={styles.overlay}/>
          <div className={styles.relativeArtCropContainer}>
            <div className={styles.overflowArtCrop} style={artCropStyles}/>
            <div className={styles.standardArtCrop} style={artCropStyles}/>
          </div>
        </div>
        <div className={styles.cardtypecontainer}>
          <HiddenField
            className={classNames(styles.showtype, styles[`textSize${Math.min(10, typeLengthIndex)}`])}
            key={1}
            word={typeParts[0]!}
            correctGuesses={correctGuesses}
            fieldRevealed={!isHardMode}
          />
          {typeParts.length === 2 &&
            <HiddenField
            className={classNames(styles.cardtype, styles[`textSize${Math.min(10, typeLengthIndex)}`])}
            key={2}
            word={` —${typeParts[1]!}`}
            correctGuesses={correctGuesses}
          />
          }
        </div>
        <div className={styles.cardTextContainer}>
          {oracleTextParts.map((part:string, index:number) => (
              <HiddenField
                className={classNames(styles.cardtext, styles[`textSize${Math.min(9, lengthIndex)}`])}
                // cardfield="cardtext"
                key={index}
                word={part}
                correctGuesses={correctGuesses}
                size={16}
                lengthIndex={lengthIndex}
              />
            ))
          }
        </div>
        {(card.power || card.toughness) &&
          <div className={styles.pt}>
            <HiddenField
                className={styles.cardpower}
                word={card.power || ''}
                correctGuesses={correctGuesses}
            />
            <p id="cardpower">{"/"}</p>
            <HiddenField
                className={styles.cardtoughness}
                word={card.toughness || ''}
                correctGuesses={correctGuesses}
            />
          </div>
        }
      </div>
  )
}

export default CardFields